module.exports = __webpack_public_path__ + "img/megamillions_icon.d256ab22.png";